<template>
  <el-dialog
    :title="$t('basicData.CustomVersion')"
    :visible.sync="dialogVisible"
    width="900px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :append-to-body="true"
    :show-close="false"
  >
    <!-- 筛选条件区域 -->
    <div class="filter-section">
      <el-form :model="filterForm" label-position="top" size="small">
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item :label="$t('basicData.siteName')">
              <el-input
                v-model="filterForm.siteName"
                disabled
                :placeholder="$t('basicData.DataDerivedNotModifiable')"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('basicData.QuotationMatchingDimensions')">
              <el-input
                v-model="filterForm.matchDimension"
                disabled
                :placeholder="$t('basicData.DataDerivedNotModifiable')"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('placeOrder.goodType')">
              <el-input
                v-model="filterForm.cargoType"
                disabled
                :placeholder="$t('basicData.DataDerivedNotModifiable')"
              />
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item :label="$t('basicData.QuotationVersionSelection')">
              <el-input
                v-model="filterForm.searchKeyword"
                :placeholder="$t('basicData.PleaseEnterQuotationPlanNameForFuzzySearch')"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item class="searchBtn">
              <!--              <el-button type="primary" size="small" @click="handleSearch">{{ $t('basicData.Search') }}</el-button>-->
              <el-button size="small" @click="handleReset">{{ $t('basicData.reset') }}</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 表格区域 -->
    <div class="table-section">
      <el-table
        :data="filteredTableData"
        border
        size="small"
        style="width: 100%"
      >
        <el-table-column
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            <el-radio
              v-model="selectedVersion"
              :label="scope.row.id"
              @change="handleSelectChange(scope.row)"
            >
              &nbsp;
            </el-radio>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('basicData.TheNameOfTheQuoteProposal')"
          prop="name"
          min-width="200"
        />
        <el-table-column
          :label="$t('basicData.TheValidityPeriodBegins')"
          prop="startOfValidityPeriod"
          width="180"
        />
      </el-table>
    </div>

    <!-- 底部按钮 -->
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="handleCancel">{{ $t('basicData.Cancel') }}</el-button>
      <el-button type="primary" size="small" @click="handleConfirm">{{ $t('basicData.determine') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'RecalculateDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    // 报价数据
    quotationList: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dialogVisible: false,
      filterForm: {
        siteName: '',
        matchDimension: '',
        cargoType: '',
        searchKeyword: ''
      },
      versionList: [],
      selectedVersion: null,
      selectedRow: null
    };
  },
  computed: {
    // 本地过滤后的表格数据
    filteredTableData() {
      if (!this.filterForm.searchKeyword) {
        return this.versionList.slice(0, 5); // 默认只显示5条
      }
      const keyword = this.filterForm.searchKeyword.toLowerCase();
      return this.versionList.filter(item =>
        item.name && item.name.toLowerCase().includes(keyword)
      ).slice(0, 5);
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
      if (val) {
        this.initFilterForm();
      }
    },
    quotationList: {
      handler() {
        this.initFilterForm();
      },
      deep: true
    },
    'filterForm.searchKeyword': {
      handler() {
        // 重置选择
        this.selectedVersion = null;
        this.selectedRow = null;
      }
    }
  },
  methods: {
    // 初始化筛选表单
    initFilterForm() {
      this.filterForm = {
        siteName: this.quotationList.siteName || '',
        matchDimension: this.quotationList.matchDimension || '',
        cargoType: this.quotationList.cargoType || '',
        searchKeyword: '' // 报价名称
      };
      this.versionList = this.quotationList.versionList || [];
      this.selectedVersion = null;
      this.selectedRow = null;
    },

    // 本地查询
    // handleSearch() {
    //   // 本地查询，computed 会自动过滤
    //   console.log('执行本地查询');
    // },

    // 查询重置
    handleReset() {
      this.filterForm.searchKeyword = '';
    },

    // 报价改变
    handleSelectChange(row) {
      this.selectedRow = row;
    },

    handleClose() {
      this.selectedVersion = null;
      this.selectedRow = null;
      this.handleCancel();
    },

    handleCancel() {
      this.dialogVisible = false;
      this.$emit('close');
    },

    handleConfirm() {
      if (!this.selectedRow) {
        this.$message.warning(this.$t('basicData.PleaseSelectQuotationPlan'));
        return;
      }
      this.handleCancel();
      this.$emit('confirm', this.selectedRow);
    }
  }
};
</script>

<style scoped lang="scss">
.filter-section {
  margin-bottom: 20px;

  ::v-deep .el-form-item {
    margin-bottom: 18px;
  }
}

.searchBtn {
  padding-top: 28px;
}

.table-section {
  margin-bottom: 20px;

  ::v-deep .el-radio {
    width: 100%;

    .el-radio__label {
      display: none;
    }
  }
}

.dialog-footer {
  text-align: right;
}
</style>
